export class GetAllRoleComponentsRequest {
  merchantGroupId: number;
}
